import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const PushBulletShape = {
  email: Yup.string().label("Pushbullet Email").email().required(),
};

export interface PushBulletInput {
  email: string;
}

yupResolver<PushBulletInput>(Yup.object().shape(PushBulletShape));
